import { useEffect, useState } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

/** `matchMedia`, or null where it does not exist (jsdom, SSR, an old webview) — same guard `lib/theme.ts` uses. */
function mediaList(): MediaQueryList | null {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return null;
  return window.matchMedia(QUERY);
}

/** Honours the OS setting; the map and the timers stop animating when it is on. */
export function useReducedMotion(): boolean {
  const [reduced, setReduced] = useState(() => mediaList()?.matches ?? false);

  useEffect(() => {
    const media = mediaList();
    if (!media) return;
    const listener = (event: MediaQueryListEvent) => setReduced(event.matches);
    media.addEventListener('change', listener);
    return () => media.removeEventListener('change', listener);
  }, []);

  return reduced;
}
